import type {
  AssistantAccommodationOfferPageSubmitPayload,
  AssistantCreateMessageRequest,
  AssistantSubmitPayload,
  AssistantTripPlannerSubmitPayload,
} from './types'
import { assertUnreachable } from 'lib/staticAssert/staticAssertUtils'

export function mapAssistantSubmitPayloadToCreateMessageRequest(
  payload: AssistantSubmitPayload,
): AssistantCreateMessageRequest {
  switch (payload.surface) {
    case 'trip_planner':
      return mapTripPlannerSubmitPayload(payload)
    case 'accommodation_offer_page':
      return mapAccommodationOfferPageSubmitPayload(payload)
    default:
      return assertUnreachable(payload)
  }
}

function mapTripPlannerSubmitPayload(
  payload: AssistantTripPlannerSubmitPayload,
): AssistantCreateMessageRequest {
  if (payload.assistantMessageId !== undefined) {
    return {
      chatId: payload.chatId,
      content: payload.content,
      ...(payload.fileIds !== undefined ? { fileIds: payload.fileIds } : {}),
      ...(payload.files !== undefined ? { files: payload.files } : {}),
      userMessageId: payload.userMessageId,
      assistantMessageId: payload.assistantMessageId,
      userData: payload.userData,
      surface: 'trip_planner',
      ...(payload.prompt !== undefined ? { prompt: payload.prompt } : {}),
    }
  }

  return {
    chatId: payload.chatId,
    content: payload.content,
    userMessageId: payload.userMessageId,
    regenerateMessageId: payload.regenerateMessageId,
    userData: payload.userData,
    surface: 'trip_planner',
    ...(payload.prompt !== undefined ? { prompt: payload.prompt } : {}),
  }
}

function mapAccommodationOfferPageSubmitPayload(
  payload: AssistantAccommodationOfferPageSubmitPayload,
): AssistantCreateMessageRequest {
  if (payload.assistantMessageId !== undefined) {
    return {
      chatId: payload.chatId,
      content: payload.content,
      ...(payload.fileIds !== undefined ? { fileIds: payload.fileIds } : {}),
      ...(payload.files !== undefined ? { files: payload.files } : {}),
      userMessageId: payload.userMessageId,
      assistantMessageId: payload.assistantMessageId,
      userData: payload.userData,
      surface: 'accommodation_offer_page',
      surfaceContext: payload.surfaceContext,
      ...(payload.prompt !== undefined ? { prompt: payload.prompt } : {}),
    }
  }

  return {
    chatId: payload.chatId,
    content: payload.content,
    userMessageId: payload.userMessageId,
    regenerateMessageId: payload.regenerateMessageId,
    userData: payload.userData,
    surface: 'accommodation_offer_page',
    surfaceContext: payload.surfaceContext,
    ...(payload.prompt !== undefined ? { prompt: payload.prompt } : {}),
  }
}
